import React, { useState } from "react";
import { UserPic } from "../molecules/user";
import { HomePic } from "../molecules/home";
import { Preloader } from "../../../common/ui/Preloader/preloader";
import { SettingsAcc } from "../molecules/SettingsAcc";
import { ConfirmPopup } from "../../../common/ui/Popups/ConfirmPopup/ConfirmPopup";
import { PassChangePopup } from "../../../common/ui/Popups/PassChangePopup/PassChangePopup";
import { EmailChangePopup } from "../../../common/ui/Popups/EmailChangePopup/EmailChangePopup";
import { useHistory, Redirect } from "react-router-dom";
import { $companies, queryCompanies } from "../../../common/companies2";
import {
  $accounts,
  queryAccounts,
  queryAccountsDelete,
  queryAccountsChange,
  updateAccount,
  AddChargesToAccount,
  AddOwnerTypeToAccount,
  AccountsDoneLoading,
} from "../../../common/accounts2";
import { queryUser, $user } from "../../../common/user";
import { useStore } from "effector-react";
import { IAccount } from "../../../common/accounts2";
import { loggedIn } from "../../login/logics/reg";
import { pathLogin, pathAddAccount, pathMain } from "../../../common/config/vars";
import { validatePhoneRU } from "../../../common/functions";
import "../styles/Settings.css";
import { $SiteColors } from "../../../common/config/company-atts";
import { getCustomUserAgent, getCustomUserAgentKrk } from "../../../common/customUserAgent";
import { PhoneChangeBlock } from "../molecules/PhoneChangeBlock";
import { UserPopup } from "../../../common/ui/Popups/PhoneChangePopup";

export const SettingsBlock = () => {
  const history = useHistory();
  const { loaded, fail, accounts } = useStore($accounts);
  const companies = useStore($companies);
  const user = useStore($user);

  const [openDeletePopup, setOpenDeletePopup] = React.useState(false);
  const [chosenAcc, setChosenAcc] = React.useState<IAccount | null>(null);
  const [errorMessage, setErrorMessage] = React.useState({
    status: false,
    message: "",
  });
  const [deleteLoader, setDeleteLoader] = React.useState(false);
  const [openChangePassPopup, setOpenChangePassPopup] = React.useState(false);
  const [openUserPopup, setOpenUserPopup] = React.useState({
    open: false,
    type: "",
  });
  const [openPhonePopUp,setOpenPhonePopUp] = useState(false)
  const [openChangeEmailPopup, setOpenChangeEmailPopup] = React.useState(false);

  React.useEffect(() => {
    if (accounts.length === 0 && companies.length === 0) {
      queryCompanies();
      queryAccounts()
      .then(async res => {
        var bar = new Promise((resolve, reject) => {
          if (res.accounts.length === 0) { resolve("@"); return } // нет ЛС — сразу завершаем, иначе загрузка зависнет
          res.accounts.forEach(async (elem, index) => {
              await updateAccount({ account: elem, accounts: res.accounts });
            await AddChargesToAccount({ account: elem, accounts: res.accounts })
            if(getCustomUserAgent() === getCustomUserAgentKrk()
            // ||getCustomUserAgent() === getCustomUserAgentASB()
            ){
              await AddOwnerTypeToAccount({ account: elem, accounts: res.accounts })
            }
            if (index === res.accounts.length - 1) resolve("@");
          })
        })
         bar.then(() => {
          AccountsDoneLoading()
        }).finally(()=>  {
          AccountsDoneLoading()
        } )
      });
    }
    if (user.needToReload) queryUser();
  }, [accounts.length, companies.length, user.needToReload]);

  function goBack() {
    history.push(pathMain);
  }

  function goAddAccount() {
    history.push(pathAddAccount);
  }

  function findCompanyName(acc: IAccount) {
    const ownCompany = companies.find(
      (company) => +company.id === acc.companyId
    );
    if (ownCompany) return ownCompany.name;
  }

  function deleteAccount() {
    if (chosenAcc !== null) {
      const newAccs = accounts.filter((acc) => acc.id !== chosenAcc.id);
      setDeleteLoader(true);
      queryAccountsDelete(chosenAcc)
        .then((res) => {
          console.log(res)
          if (res.success) {
            queryAccountsChange(newAccs);
            setOpenDeletePopup(false);
            setErrorMessage({ ...errorMessage, status: false });
          }
          if (res.err_code === 10006)
            throw new Error("К аккаунту привязаны другие пользователи");
          else throw new Error("Что-то пошло не так(");
        })
        .catch((err) =>
          setErrorMessage({
            ...errorMessage,
            status: true,
            message: err.message,
          })
        )
        .finally(() => setDeleteLoader(false));
    }
  }

  function openNamePopup() {
    setOpenUserPopup({ type: "name", open: true });
  }

  function openEmailPopup() {
    setOpenChangeEmailPopup(true);
  }

  function openPhonePopup() {
    setOpenPhonePopUp(true);
  }

  function openAddUserPopup() {
    setOpenUserPopup({ type: "addSlaveUser", open: true });
  }

  return !loggedIn() ? (
    <Redirect to={pathLogin} />
  ) : (
    <>
      <section className="page__content page__content_overflow">
        <div className="page__title-container">
          <nav className="page__navigation page__navigation_title-bar">
            <button
              type="button"
              className="page__navigation-button page__navigation-button_title-bar"
              onClick={goBack}
              style={{color:$SiteColors.getState().sideBarText}}
            >
              Назад
            </button>
          </nav>
          <h1 className="page__title page__title_no-padding" style={{color:$SiteColors.getState().titleColor}}>Настройки</h1>
        </div>
        <div className="page__without-sidebar">
        <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
            <div className="page__data-card">
              <div className="data-card__header">
                <UserPic />
                <h2 className="data-card__title">Информация о пользователе</h2>
              </div>
              {!user.loaded && (
                <div className="settings__loader-padding">
                  <Preloader small={false} />
                </div>
              )}
              {user.loaded && (
                <>
                  <div className="data-card__string-container">
                    <p className="data-card__text">
                      <span>Собственник:</span>
                      {user.firstName || "Не задано"}
                    </p>
                    <button
                      className="data-card__button"
                      onClick={openNamePopup}
                    >
                      {user.firstName
                        ? "Сменить имя аккаунта"
                        : "Добавить имя аккаунта"}
                    </button>
                  </div>
                  <div className="data-card__string-container">
                    <p className="data-card__text">
                      <span>Email:</span>
                      {user.email || "Не задано"}
                    </p>
                    <button
                      className="data-card__button"
                      onClick={openEmailPopup}
                    >
                      {user.email ? "Сменить Email" : "Привязать Email"}
                    </button>
                  </div>
                  <div className="data-card__string-container">
                    <p className="data-card__text">
                      <span>Телефон:</span>
                      {validatePhoneRU(user.phone).phone}
                    </p>
                    <button
                      className="data-card__button"
                      onClick={openPhonePopup}
                    >
                      Сменить номер
                    </button>
                  </div>
                </>
              )}
            </div>
            <div className="page__data-card">
              <div className="data-card__header">
                <HomePic />
                <h2 className="data-card__title">Мои лицевые счета</h2>
                <button
                  className="data-card__button"
                  type="button"
                  onClick={goAddAccount}
                >
                  Добавить ЛС
                </button>
              </div>
              <ul className="settings__accs-list">
                {!loaded && <Preloader small={false} />}
                {loaded &&
                  companies.length !== 0 &&
                  accounts.map((account, i) => (
                    <SettingsAcc
                      key={i}
                      account={account}
                      findCompanyName={findCompanyName}
                      setOpenDeletePopup={setOpenDeletePopup}
                      setChosenAcc={setChosenAcc}
                      setOpenChangePassPopup={setOpenChangePassPopup}
                      openAddUserPopup={openAddUserPopup}
                      userId={user.id}
                    />
                  ))}
                {loaded && fail && (
                  <p className="settings__text">
                    Не удалось загрузить лицевые счета
                  </p>
                )}
                {loaded && accounts.length === 0 && (
                  <p className="settings__text">
                    Здесь будут отображены подключенные Вами лицевые счета
                  </p>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {openDeletePopup && (
        <ConfirmPopup
          openDeletePopup={openDeletePopup}
          setOpenDeletePopup={setOpenDeletePopup}
          deleteAccount={deleteAccount}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          deleteLoader={deleteLoader}
        />
      )}
      {openChangePassPopup && chosenAcc && (
        <PassChangePopup
          openChangePassPopup={openChangePassPopup}
          setOpenChangePassPopup={setOpenChangePassPopup}
          chosenAcc={chosenAcc}
        />
      )}
      {openUserPopup.open && (
        <UserPopup
          openUserPopup={openUserPopup}
          setOpenUserPopup={setOpenUserPopup}
          user={user}
          chosenAcc={chosenAcc}
        />
      )}
       {openPhonePopUp && (
        <PhoneChangeBlock setClose={setOpenPhonePopUp}/>
        
      )}
      {openChangeEmailPopup && (
        <EmailChangePopup
          openChangeEmailPopup={openChangeEmailPopup}
          setOpenChangeEmailPopup={setOpenChangeEmailPopup}
          user={user}
        />
      )}
    </>
  );
};
